import script from "./TestMonthly.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestMonthly.vue?vue&type=script&lang=ts&setup=true"

import "./TestMonthly.vue?vue&type=style&index=0&id=0be8ee1e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be8ee1e"]])

export default __exports__